import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled, { keyframes } from 'styled-components'
class HeroPersonal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {
        const [{ content: { frontmatter: { greetingMessage = 'Hello', headline = '', personName = '', bgImage } = {} } = {} }] = this.props.items;
        const Section = styled.section`
            position: relative;
            .particles {
                position: absolute;
                width: 100%;
                height: 100%;
            }
            background-image: url(${bgImage || this.props.background.childImageSharp.fluid.src});
            background-size: contain;
            background-repeat: no-repeat;
            background-position-x: 100%;
            background-position-y: 16px;
            @media (max-width: 767px) {
                background-image: none;
            }
            @media (min-width: 768px) and (max-width: 1920px) {
                background-position-x: 104%;
            }
            @media (min-width: 1921px) {
                background-position-x: 105%;
            }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
        `

        const Heading = styled.div`
            .glitch {
                font-size: 100px;
                line-height: 100px;
                font-weight: 600;
                color: #fff;
                @media (max-width: 767px) {
                    font-size: 40px;
                    line-height: 50px;
                }
            }
        `

        const SubHeading = styled.h2`
            font-size: 24px;
            font-weight: 300;
            color: #ccc;
            text-transform: uppercase;
            letter-spacing: 4px;
        `
        const Type = styled.div`
            font-size: 50px;
            line-height: 50px;
            color: #fff;
            text-transform: uppercase;
            margin-left: 6px;
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 23px;
                line-height: 20px;
            }
            @media (max-width:767px) {
                font-size: 20px;
                line-height: 20px;
            }
            span {
                font-family: Teko;
            }
        `
        // 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073, 0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073, 0 0 70px #e60073
        const AnimatedShadow = keyframes`
            0%   {text-shadow: 0 0 10px #fff}
            10%  {text-shadow: 0 0 20px #fff}
            20%  {text-shadow: 0 0 30px #e60073}
            30%  {text-shadow: 0 0 40px #e60073}
            40% {text-shadow: 0 0 50px #e60073}
            50% {text-shadow: 0 0 60px #e60073}
            60% {text-shadow: 0 0 70px #e60073}
            70% {text-shadow: 0 0 50px #e60073}
            80% {text-shadow: 0 0 60px #e60073}
            90% {text-shadow: 0 0 70px #e60073}
            100% {text-shadow: 0 0 40px #e60073}
        `
        const NameHeading = styled.h1`
            font-family: "Rye", cursive;
            font-size: 96px;
            line-height: 150px;
            color: #FFF;
            animation: ${AnimatedShadow} 10s infinite alternate;
            @media (max-width: 767px) {
                font-size: 36px;
                line-height: 48px;
            }
        `

        const NameTitle = styled.h3`
            font-family: "Stardos Stencil", cursive;
            font-size: 36px;
            line-height: 48px;
            color: #FFF;
            text-align: center;
            text-transform: capitalize;
            @media (max-width: 767px) {
                font-size: 16px;
                line-height: 24px;
            }
        `
        const gradientAnimation = keyframes`
            0% {
              background-position: 15% 0%;
            }
            50% {
              background-position: 85% 100%;
            }
            100% {
              background-position: 15% 0%;
            }
          `


        const HeadingBox = styled.div`
            height: 500px;
            width: 900px;
            margin: auto;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;
            &:after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                border-radius: 5px;
                background-size: 300% 300%;
                clip-path: polygon(0% 100%, 10px 100%, 10px 10px, calc(100% - 10px) 10px, calc(100% - 10px) calc(100% - 10px), 10px calc(100% - 10px), 10px 100%, 100% 100%, 100% 0%, 0% 0%);
            }
            &.animate:after {
                animation: ${gradientAnimation} 2s ease-in-out infinite;
            }
            @media (max-width: 767px) {
                height: 350px;
            }
        `

        return (
            <Section id="home">
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 350}px` }}>
                    <HeadingBox className="parallax-hero-item animate">
                        <SubHeading className="parallax-hero-item">
                            {greetingMessage}
                        </SubHeading>
                        <Heading className="parallax-hero-item">
                            <NameHeading>{personName}</NameHeading>
                        </Heading>
                        <Type className="parallax-hero-item">
                            {/* <Typewriter
                                options={{
                                    strings: [
                                        'Music Composer',
                                        'Music Producer',
                                        'Orchestrator',
                                    ],
                                    autoStart: true,
                                    loop: true,
                                }}
                            /> */}
                            <NameTitle>{headline}</NameTitle>
                        </Type>
                    </HeadingBox>
                    {/* {this.shapes()} */}
                </Overlay>
            </Section>
        )
    }

    /* shapes() {

        const MoveUp = keyframes`
            0% { 
                transform: translateY(0);
            }
            100% {
                transform: translateY(-40px);
            }
        `

        const MoveDown = keyframes`
            0% { 
                transform: translateY(0);
            }
            100% {
                transform: translateY(40px);
            }
        `
        const Shape = styled.img`
            position: absolute;
            height: 50px;
            &.move-up {
                animation: ${MoveUp} 3s infinite alternate;
            }
            &.move-down {
                animation: ${MoveDown} 3s infinite alternate;
            }
            @media (max-width: 767px) {
                height: 20px;
            }
        `
        


        return this.props.shapes.map((value, index) => {
            return (
                <Shape
                    style={{
                        left: `${(index+1) * 10}%`,
                        bottom: `${Math.random() *
                        (+((index+1) % 2 === 0 ? 10 : 90) - +((index+1) % 2 === 0 ? 5 : 80)) +
                        +((index+1) % 2 === 0 ? 5 : 80)}%`,
                    }}
                    key={index}
                    src={value.node.childImageSharp.fluid.src}
                    alt="shape"
                    className={Math.floor(Math.random() * 10) % 2 === 0 ? "move-up" : "move-down"}
                />
            )
        })
    } */
}
export default props => (
    <StaticQuery
        query={graphql`
      query {
        background: file(relativePath: {eq: "Srikant-Personal.png"}) {
          childImageSharp {
            fluid(maxWidth: 2000, quality: 100) {
              src
            }
          }
        }
        shapes: allFile(filter: {extension: {regex: "/(png)/"}, relativeDirectory: {eq: "shapes"}}) {
          edges {
            node {
              childImageSharp {
                fluid(maxWidth: 100) {
                  src
                }
              }
            }
          }
        }
        items: allMarkdownRemark(sort: {fields: [frontmatter___id], order: ASC}, limit: 50, filter: {fileAbsolutePath: {regex: "/(hero-section)/"}, internal: {type: {eq: "MarkdownRemark"}}}) {
            edges {
              content: node {
                frontmatter {
                  greetingMessage
                  headline
                  personName
                  bgImage
                }
                fileAbsolutePath
                internal {
                  type
                }
              }
            }
        }
      }      
      `}
        render={({ background, shapes, items }) => <HeroPersonal background={background} shapes={shapes.edges} items={items.edges} {...props} />}
    />
)